// extracted by mini-css-extract-plugin
module.exports = {"bg-size":"NavHeader_bg-size__mxXHn"};